import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const [session, setSession] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSessionAndAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setSession(session);

      if (session && requireAdmin) {
        const response = await fetch('/.netlify/functions/isAdmin', {
          headers: { Authorization: `Bearer ${session.access_token}` },
        });
        const data = await response.json();
        setIsAuthorized(data.authorized);
      }

      setLoading(false);
    };

    fetchSessionAndAuth();
  }, [requireAdmin]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!session) {
    return <Navigate to="/" replace />;
  }

  if (requireAdmin && !isAuthorized) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;